import './why-us.component.css';

export function WhyUs() {
    return (
        <div id="why-us" className="section why-us">
                <div className="section-header text-center">
                    <h2>Why VKC Trainings</h2>
                    <p className="lead">Real Time Training with Placements</p>
                </div>
				{/* container */}
				<div className="container">
                    
					{/* row */}
                    <div className="row">

                        <div className="col-md-6">
                            {/* row */}
                            <div className="row">                               
                                <ul>
                                    <li>Explaing With Realtime Concepts</li>
                                    <li>Everyday Labs for Practice</li>
                                    <li>Doubt Solving Sessions</li>
                                    <li>Interview Preparation</li>
                                    <li>Resume Building</li>
                                    <li>Course Certification</li>
                                    <li>Topic wise Study Material</li>
                                    <li>Recording Sessions</li>
                                </ul>
                            </div>
                        {/* /row */}
						</div>

						<div className="col-md-5 col-md-offset-1">
							<a className="about-video" href="#">
								<img src={require("../../../img/about-video.jpg")} alt=""></img>
								<i className="play-icon fa fa-play"></i>
							</a>
						</div>

					</div>
					{/* /row */}

				</div>
				{/* /container */}

			</div>
    )
}